export default "__VITE_ASSET__CONc0GZd__"